// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"c0034a70","130":"68195ac6","238":"a606143d","367":"2515d96d","573":"2b22d678","589":"0193bb0f","629":"e8a67164","646":"15448074","715":"77c6ada6","777":"48a0c906","857":"d8fa1667","881":"4424c771","919":"f92e9b59","987":"1a2e70c3"}[chunkId] + ".chunk.js";
};